module.exports = __webpack_public_path__ + "media/flags/ug-5f94cebe.svg";